var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"duo-content-wrap rule-container",staticStyle:{"text-align":"left"}},_vm._l((_vm.rule.content),function(item,index){return _c('div',{key:index,style:(item.style)},[_vm._v(" "+_vm._s(item.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }